export default __webpack_public_path__ + "static/media/saturn3.8f64837e.png";